export const NOT_FOUND_PAGE = {
  GO_HOME_BUTTON: 'not-found-page-go-home-button'
} as const;
